import { Mesh, PlaneGeometry, MeshBasicMaterial, DoubleSide } from "three";

export class PlanoHotSpot extends Mesh {
	constructor(name, width = 1, height = 1, position = { x: 0, y: 0, z: 0 }, color = 0xffff00) {
		super();
		this.name = name;
		this.geometry = new PlaneGeometry(width, height);
		this.material = new MeshBasicMaterial({ color: color });
		this.position.set(position.x, position.y, position.z);
	}
	onUpdateTexture(material) {
		this.material = material;
		this.material.side = DoubleSide;
	}
}
